import PatientsDesktop from './patients-desktop';

export default PatientsDesktop;
